export default __webpack_public_path__ + "static/media/findel-logo.3723fb31.svg";